import { useQuery } from "@tanstack/react-query";
import { db } from "@/modules/shared/lib/db-client";
import { useAuth } from "./useAuth";
import { log } from "@/modules/shared/lib/observability";

export function usePlatformAdmin() {
  const { user, loading: authLoading } = useAuth();

  const { data: isPlatformAdmin = false, isLoading: queryLoading } = useQuery({
    queryKey: ["is-platform-admin", user?.id],
    queryFn: async () => {
      if (!user?.id) return false;

      const { data, error } = await db.rpc("is_platform_admin");

      if (error) {
        log.error("Error checking platform admin status", {}, error);
        return false;
      }

      return !!data;
    },
    enabled: !authLoading && !!user?.id,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });

  return {
    isPlatformAdmin,
    isLoading: authLoading || queryLoading,
  };
}
